(function () {
  function qs(sel, root=document){ return root.querySelector(sel); }
  function qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

  const MOBILE_SPB_MEDIA = window.matchMedia('(max-width: 989px)');

  function syncGlobalSpbState() {
    const stickyBarSuppressed = document.body.classList.contains('ry-pswp-open');
    const anyActive = qsa('[data-spb]').some((item) => {
      return item.classList.contains('is-visible') || item.classList.contains('is-size-open');
    });

    document.body.classList.toggle('spb-active', MOBILE_SPB_MEDIA.matches && anyActive && !stickyBarSuppressed);
  }

  function openCartDrawerBestEffort() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    const cartButton =
      qs('[data-drawer-trigger="cart"]') ||
      qs('[data-cart-drawer-open]') ||
      qs('a[href="/cart"]') ||
      qs('button[name="checkout"]');

    if (cartButton) cartButton.click();
  }

  async function addToCart(variantId, quantity=1) {
    const res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function parseVariantMap(bar) {
    const variantJson = qs('[data-spb-variants]', bar);
    if (!variantJson) return new Map();

    try {
      const parsed = JSON.parse(variantJson.textContent || '[]');
      return new Map(parsed.map((variant) => [String(variant.id), variant]));
    } catch (error) {
      console.warn('SPB variant map parse failed', error);
      return new Map();
    }
  }

  function getProductRoot(bar) {
    const rootId = bar.dataset.productRootId || (bar.dataset.productId ? `product-${bar.dataset.productId}` : '');
    return rootId ? document.getElementById(rootId) : null;
  }

  function getButtonsArea(bar) {
    const productRoot = getProductRoot(bar);
    return productRoot ? (qs('.cc-product-buttons', productRoot) || productRoot) : document;
  }

  function getCurrentVariantInput(bar) {
    const productRoot = getProductRoot(bar) || document;
    return (
      qs('form[id^="product-form-buttons-"] input[name="id"]', productRoot) ||
      qs('form[id^="product-form-buttons-"] #formVariantId', productRoot) ||
      qs('.js-prod-form-submit input[name="id"]', productRoot) ||
      qs('#formVariantId', productRoot)
    );
  }

  function getVariantState(bar, variantMap) {
    const variantInput = getCurrentVariantInput(bar);
    const fallbackId = bar.dataset.initialVariantId || '';
    const variantId = String((variantInput && variantInput.value) || fallbackId || '');
    const variant = variantMap.get(variantId) || null;

    return {
      id: variantId,
      available: variant ? !!variant.available : bar.dataset.initialAvailable === 'true',
      price: (variant && variant.price) || bar.dataset.initialPrice || ''
    };
  }

  function scoreNotifyCandidate(element) {
    const haystack = [
      element.id || '',
      element.className || '',
      element.getAttribute('aria-label') || '',
      element.getAttribute('data-testid') || '',
      element.getAttribute('title') || '',
      element.textContent || ''
    ].join(' ').toLowerCase();

    let score = 0;
    if (haystack.includes('klaviyo')) score += 5;
    if (haystack.includes('notify me')) score += 5;
    if (haystack.includes('back in stock')) score += 4;
    if (haystack.includes('when available')) score += 4;
    if (haystack.includes('email me')) score += 3;
    if (element.classList.contains('cc-klaviyo-bis-button')) score += 6;
    if (element.classList.contains('klaviyo-bis-trigger')) score += 6;
    if (element.tagName && element.tagName.toLowerCase() === 'button') score += 1;
    return score;
  }

  function findNotifyTrigger(bar) {
    const buttonsArea = getButtonsArea(bar);
    if (!buttonsArea) return null;

    const excludedSelector = [
      '.js-ajax-submit',
      '.product__quantity-down',
      '.product__quantity-up',
      '.product__quantity-input'
    ].join(', ');

    const candidates = qsa('button, a, [role="button"]', buttonsArea)
      .filter((element) => {
        if (!(element instanceof Element)) return false;
        if (element.closest('[data-spb]')) return false;
        if (element.matches(excludedSelector)) return false;
        if (element.closest('.product__quantity, .notify-form__inner-wrapper, .product-form__notify-form')) return false;
        if (element.disabled) return false;
        return scoreNotifyCandidate(element) > 0;
      })
      .sort((a, b) => scoreNotifyCandidate(b) - scoreNotifyCandidate(a));

    return candidates[0] || null;
  }

  function waitForNotifyTrigger(bar, timeout=1600) {
    const existing = findNotifyTrigger(bar);
    if (existing) return Promise.resolve(existing);

    const buttonsArea = getButtonsArea(bar);
    if (!buttonsArea) return Promise.resolve(null);

    return new Promise((resolve) => {
      let settled = false;
      const cleanup = () => {
        observer.disconnect();
        clearTimeout(timer);
      };
      const finish = (element) => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(element || null);
      };

      const observer = new MutationObserver(() => {
        const found = findNotifyTrigger(bar);
        if (found) finish(found);
      });

      observer.observe(buttonsArea, { childList: true, subtree: true, attributes: true });

      const timer = setTimeout(() => finish(findNotifyTrigger(bar)), timeout);
    });
  }

  function initBar(bar) {
    const btn = qs('[data-spb-btn]', bar);
    const drawer = qs('[data-spb-drawer]', bar);
    const needsSelection = bar.dataset.needsSelection === 'true';
    const variantMap = parseVariantMap(bar);
    const productRoot = getProductRoot(bar);

    const formButtons =
      (productRoot && (
        qs('form[id^="product-form-buttons-"]', productRoot) ||
        qs('.product-form__buttons', productRoot) ||
        qs('product-form form[action^="/cart/add"]', productRoot) ||
        qs('form[action^="/cart/add"]', productRoot)
      )) ||
      qs('form[id^="product-form-buttons-"]') ||
      qs('.product-form__buttons') ||
      qs('product-form form[action^="/cart/add"]') ||
      qs('form[action^="/cart/add"]');

    const footer =
      qs('footer') ||
      qs('#shopify-section-footer') ||
      qs('[data-section-type="footer"]');

    // RYNOR bundle upsell (snippets/bundle-upsell.liquid): while a 3 / 7 piece bundle is picked,
    // this bar shows "ADD 3 PIECES - $75.00" and adds the bundle instead of the single piece.
    const upsellEl = productRoot ? qs('rynor-bundle-upsell', productRoot) : null;
    const bundleCta = upsellEl ? qs('[data-cta]', upsellEl) : null;
    function bundleOn() {
      return !!(upsellEl && typeof upsellEl.isBundleActive === 'function' && upsellEl.isBundleActive());
    }

    // v54 docked style (Theme settings → Product forms → "Docked sticky add to cart"):
    // the page button this bar merges into, and the label it copies from it.
    const docked = bar.classList.contains('spb--docked');

    function dockTarget() {
      if (!formButtons) return null;
      // the bundle's own button takes the place of Add to cart while a bundle is picked
      if (bundleOn() && bundleCta && bundleCta.offsetParent !== null) return bundleCta;
      const box = qs('[data-cc-product-button-container], .product__add-inner-container', formButtons);
      if (!box) return formButtons;
      // usual case: one button in the bordered box → copy the whole box
      const shown = qsa('.product-form__add-to-cart--text', box).filter((el) => el.offsetParent !== null);
      const qty = qs('.product-form__add-to-cart--qty', box);
      if (shown.length <= 1 && !(qty && qty.offsetParent !== null)) return box;
      // quantity box or notify button beside it → copy just the button that's in use
      return shown.find((el) => !el.disabled) || shown[0] || box;
    }

    function dockButton(target) {
      if (!target) return null;
      if (target.matches('button')) return target;
      return qs('.js-ajax-submit, .product-form__add-to-cart--text', target) || target;
    }

    function dockLabel() {
      if (!docked || !formButtons) return '';
      const el = bundleOn() ? bundleCta : dockButton(dockTarget());
      return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function syncButtonState() {
      if (!btn) return;

      if (bundleOn()) {
        btn.textContent = String(dockLabel() || upsellEl.stickyLabel() || '').trim();
        bar.dataset.spbMode = 'bundle';
        bar.classList.remove('is-notify-mode');
        if (drawer && !drawer.hasAttribute('hidden')) {
          drawer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          bar.classList.remove('is-size-open');
        }
        return;
      }

      const variantState = getVariantState(bar, variantMap);
      const notifyMode = !variantState.available;
      const addPrefix = bar.dataset.labelAddPrefix || 'ADD TO CART - ';
      const selectPrefix = bar.dataset.labelSelectPrefix || 'SELECT YOUR SIZE - ';
      const notifyLabel = bar.dataset.labelNotify || 'NOTIFY ME';
      const nextLabel = notifyMode
        ? notifyLabel
        : (dockLabel() || `${needsSelection ? selectPrefix : addPrefix}${variantState.price || ''}`);

      btn.textContent = nextLabel.trim();
      bar.dataset.spbMode = notifyMode ? 'notify' : (needsSelection ? 'select' : 'add');
      bar.classList.toggle('is-notify-mode', notifyMode);

      if (notifyMode && drawer && !drawer.hasAttribute('hidden')) {
        drawer.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
      }
    }

    async function openNotifyFlow() {
      btn && btn.setAttribute('aria-busy', 'true');
      try {
        const trigger = await waitForNotifyTrigger(bar);
        if (trigger) {
          trigger.click();
          return;
        }
        console.warn('Sticky product bar could not find a Klaviyo notify trigger.');
      } finally {
        btn && btn.removeAttribute('aria-busy');
      }
    }

    if (!formButtons) {
      syncButtonState();
      bar.classList.add('is-visible');
      syncGlobalSpbState();
      return;
    }

    let formVisible = false;
    let bundleCtaVisible = false;
    let footerVisible = false;
    let dockShow = true; // docked style only: false while the page's own button is on screen

    // snap = show/hide in place, without the slide (docked style hand-over)
    function setShown(show, snap) {
      if (bar.classList.contains('is-visible') === show) return;
      if (!snap) {
        bar.classList.toggle('is-visible', show);
        return;
      }
      bar.classList.add('spb--snap');
      bar.classList.toggle('is-visible', show);
      void bar.offsetWidth; // apply it now, before the slide transition comes back
      bar.classList.remove('spb--snap');
    }

    function updateVisibility(snap) {
      const shouldShow = docked
        ? (dockShow && !footerVisible)
        : ((!formVisible) && (!bundleCtaVisible) && (!footerVisible));
      setShown(shouldShow, snap === true);

      if (!shouldShow) {
        if (drawer && !drawer.hasAttribute('hidden')) drawer.setAttribute('hidden', '');
        btn && btn.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
      }

      syncButtonState();
      syncGlobalSpbState();
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === formButtons) formVisible = entry.isIntersecting;
        if (bundleCta && entry.target === bundleCta) bundleCtaVisible = entry.isIntersecting;
        if (footer && entry.target === footer) footerVisible = entry.isIntersecting;
      });
      updateVisibility();
    }, {
      root: null,
      threshold: 0.01,
      rootMargin: '0px 0px -15% 0px'
    });

    if (!docked) {
      io.observe(formButtons);
      if (bundleCta) io.observe(bundleCta);
    }
    if (footer) io.observe(footer);
    document.addEventListener('rynor:bundle-change', syncButtonState);
    if (docked) initDock();

    // -------------------------------------------------------------------------------------
    // v54 DOCKED STYLE. The bar's button copies the size, position and lettering of the
    // page's own Add to cart button. Scrolling down, the bar stays until that button slides
    // up into exactly the same spot, then hands over in place, so the bar seems to become
    // the button. Once the button scrolls off the top, the bar pops back up. Only runs in
    // this style, and the scroll listener is only attached while the button is within a
    // screen's height of view.
    // -------------------------------------------------------------------------------------
    function initDock() {
      const inner = qs('.spb__inner', bar); // its bottom padding = white space under the button (+ iPhone home bar, v55)
      const probe = document.createElement('div'); // sits exactly where this browser puts "bottom: 0"
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed;left:0;bottom:0;width:0;height:0;visibility:hidden;pointer-events:none;';
      document.body.appendChild(probe);

      let state = ''; // 'below' = on its way up, 'docked' = on screen, 'above' = scrolled past
      let look = '';
      const near = new Set();
      let listening = false;

      function syncLook(target) {
        const t = target.getBoundingClientRect();
        const b = bar.getBoundingClientRect();
        if (!t.height || !b.width) return;
        const cs = getComputedStyle(dockButton(target));
        const values = [
          Math.max(0, t.left - b.left) + 'px',
          Math.max(0, b.right - t.right) + 'px',
          t.height + 'px',
          cs.fontFamily, cs.fontSize, cs.fontWeight, cs.letterSpacing, cs.textTransform
        ];
        const key = values.join('|');
        if (key === look) return;
        look = key;
        ['--spb-dock-left', '--spb-dock-right', '--spb-dock-h', '--spb-dock-font-family',
          '--spb-dock-font-size', '--spb-dock-font-weight', '--spb-dock-letter-spacing',
          '--spb-dock-text-transform'].forEach((name, i) => bar.style.setProperty(name, values[i]));
      }

      function updateDock(refresh) {
        if (!MOBILE_SPB_MEDIA.matches) return; // the bar is hidden on desktop
        const target = dockTarget();
        const t = target ? target.getBoundingClientRect() : null;
        let next = 'below';
        if (t && t.height) {
          const padBottom = inner ? (parseFloat(getComputedStyle(inner).paddingBottom) || 0) : 10;
          const dockTop = probe.getBoundingClientRect().top - padBottom - t.height;
          if (t.bottom <= 0) next = 'above';
          else if (t.top <= dockTop + 0.5) next = 'docked';
        }
        if (next === state && !refresh) return;
        if (target) syncLook(target);
        const prev = state;
        state = next;
        dockShow = next !== 'docked';
        // merging into / coming off the page's button happens in place; everything else slides
        const snap = (prev === 'below' && next === 'docked') || (prev === 'docked' && next === 'below');
        updateVisibility(snap);
      }

      const onScroll = () => updateDock(false);
      const watch = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) near.add(entry.target);
          else near.delete(entry.target);
        });
        const want = near.size > 0;
        if (want !== listening) {
          listening = want;
          if (want) window.addEventListener('scroll', onScroll, { passive: true });
          else window.removeEventListener('scroll', onScroll);
        }
        updateDock(false);
      }, { rootMargin: '100% 0px 100% 0px' });

      [qs('[data-cc-product-button-container], .product__add-inner-container', formButtons), bundleCta]
        .filter(Boolean)
        .forEach((el) => watch.observe(el));

      const refreshDock = () => updateDock(true);
      window.addEventListener('resize', refreshDock, { passive: true });
      document.addEventListener('rynor:bundle-change', refreshDock);
      if (typeof MOBILE_SPB_MEDIA.addEventListener === 'function') {
        MOBILE_SPB_MEDIA.addEventListener('change', refreshDock);
      } else if (typeof MOBILE_SPB_MEDIA.addListener === 'function') {
        MOBILE_SPB_MEDIA.addListener(refreshDock);
      }
      updateDock(true);
    }

    btn?.addEventListener('click', async () => {
      syncButtonState();
      const mode = bar.dataset.spbMode || (needsSelection ? 'select' : 'add');

      if (mode === 'bundle' && bundleOn()) {
        upsellEl.stickyAdd(btn);
        return;
      }

      if (mode === 'notify') {
        await openNotifyFlow();
        return;
      }

      if (needsSelection) {
        if (!drawer) return;

        const isOpen = !drawer.hasAttribute('hidden');
        if (isOpen) {
          drawer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          bar.classList.remove('is-size-open');
        } else {
          drawer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          bar.classList.add('is-size-open');
        }

        syncGlobalSpbState();
        return;
      }

      const variantInput = getCurrentVariantInput(bar);
      const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!variantId) return;

      btn.disabled = true;
      try {
        await addToCart(variantId, 1);
        openCartDrawerBestEffort();
      } catch(e) {
        console.warn(e);
      } finally {
        btn.disabled = false;
      }
    });

    if (drawer) {
      const closeBtn = qs('[data-spb-close]', bar);
      closeBtn?.addEventListener('click', () => {
        drawer.setAttribute('hidden', '');
        btn?.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
        syncGlobalSpbState();
      });

      qsa('[data-spb-variant-id]', drawer).forEach((sizeBtn) => {
        sizeBtn.addEventListener('click', async () => {
          const variantId = parseInt(sizeBtn.getAttribute('data-spb-variant-id'), 10);
          if (!variantId) return;

          try {
            await addToCart(variantId, 1);
            drawer.setAttribute('hidden', '');
            btn?.setAttribute('aria-expanded', 'false');
            bar.classList.remove('is-size-open');
            syncGlobalSpbState();
            openCartDrawerBestEffort();
          } catch(e) {
            console.warn(e);
          }
        });
      });

      drawer.addEventListener('click', (e) => {
        if (e.target === drawer) {
          drawer.setAttribute('hidden', '');
          btn?.setAttribute('aria-expanded', 'false');
          bar.classList.remove('is-size-open');
          syncGlobalSpbState();
        }
      });
    }

    const variantInput = getCurrentVariantInput(bar);
    variantInput?.addEventListener('change', syncButtonState);

    const buttonsArea = getButtonsArea(bar);
    if (buttonsArea) {
      new MutationObserver(syncButtonState).observe(buttonsArea, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    function syncPswp() {
      document.body.classList.toggle('spb--zoom-open', document.body.classList.contains('ry-pswp-open'));
      syncGlobalSpbState();
    }
    syncPswp();
    new MutationObserver(syncPswp).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (typeof MOBILE_SPB_MEDIA.addEventListener === 'function') {
      MOBILE_SPB_MEDIA.addEventListener('change', syncGlobalSpbState);
    } else if (typeof MOBILE_SPB_MEDIA.addListener === 'function') {
      MOBILE_SPB_MEDIA.addListener(syncGlobalSpbState);
    }

    syncButtonState();
  }

  function boot() {
    qsa('[data-spb]').forEach(initBar);
    syncGlobalSpbState();
  }

  window.addEventListener('pagehide', () => {
    document.body.classList.remove('spb-active');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
